import request from '@aned/request';

// @docs http://10.10.106.144:8088/swagger-ui.html#/%E4%B8%B4%E6%97%B6%E8%B7%AF%E7%94%B1(%E6%96%B0)%E6%9F%A5%E8%AF%A2%E6%8E%A5%E5%8F%A3

/**
 * 分页查询
 *
 * @param params 分页查询参数
 * @returns 返回请求结果的Promise对象
 */
export async function selectPage(params) {
  return request('/api/adjust/selectPage', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'temporary',
  });
}

/**
 * 获取列表数据
 *
 * @param params 请求参数
 * @returns Promise<any> 返回Promise对象，解析后得到请求结果
 */
export async function selectList(params) {
  return request('/api/adjustDetail/selectList', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'temporary',
  });
}

/**
 * 获取库存数据
 *
 * @param params 查询参数对象
 * @returns 返回Promise对象，resolve为请求结果，reject为错误信息
 */
export async function queryWaybillNoByRoute(params) {
  return request('/api/adjust/queryWaybillNoByRoute', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'temporary',
  });
}

/**
 * 临时路由申请
 *
 * @param params 申请参数对象
 * @returns Promise<any> 返回请求结果的Promise对象
 */
export async function apply(params) {
  return request('/api/adjust/apply', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'temporary',
  });
}
/**
 * 导出Excel文件
 *
 * @param params 导出Excel的参数
 * @returns 返回Promise对象，包含请求结果
 */
export async function exportExcel(params) {
  return request('/api/adjust/adjustExport', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'temporary',
  });
}

/**
 * 临时路由审批
 *
 * @param params 审计参数
 * @returns 返回一个 Promise 对象，resolve 值为请求结果，reject 值为请求错误
 */
export async function audit(params) {
  return request('/api/adjust/audit', {
    method: 'POST',
    body: params,
    module: 'temporary',
  });
}

/**
 * 备注明细获取（配置项）
 *
 * @param params 请求参数
 * @returns 返回请求结果
 */
export async function selectAdjustRemarkBaseList(params) {
  return request('/api/adjust/selectAdjustRemarkBaseList', {
    method: 'POST',
    body: params,
    module: 'temporary',
  });
}

/**
 * 根据订单号查询
 *
 * @param params 查询参数
 * @returns 返回查询结果
 */
export async function selectByOrderNo(params) {
  return request('/api/adjust/select', {
    method: 'POST',
    body: params,
    module: 'temporary',
  });
}

/**
 * 查询剩余仓位(T)
 *
 * @param params 查询参数
 * @returns 返回请求结果
 */
export async function queryGapVolume2(params) {
  return request('/api/route/queryGapVolume2', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}

/**
 * 查询统计数量
 *
 * @param params 查询参数
 * @returns 返回请求结果
 */
export async function querySummaryCount(params) {
  return request('/api/adjust/querySummaryCount', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'temporary',
  });
}

/**
 * 判断是否为限制分配
 *
 * @param params 请求参数
 * @returns Promise<any> 请求结果
 */
export async function isRestrictedAllocation(params) {
  return request('/api/adjust/isRestrictedAllocation', {
    method: 'POST',
    body: params,
    reqType: 'format',
    module: 'temporary',
  });
}

/**
 * 校验临时路由申请下一站
 * @param params 请求参数
 * @returns 返回请求结果
 */
export async function checkNextStation() {
  return request('/api/adjust/commonByKey?key=ADJUST_SITE_SWITCH', {
    method: 'POST',
    module: 'temporary',
  });
}

/**
 * 临时路由票均重校验
 *
 * @param params 查询参数
 * @returns 返回请求结果
 */
export async function checkTicketAvgWeight(params) {
  return request('/api/adjust/checkTicketAvgWeight', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'temporary',
  });
}


/**
 * 查询临调承接已调货量汇总分页
 *
 * @param params 查询参数
 * @returns 返回请求结果
 */
export async function selectAdjustWeightSumBySitePage(params) {
  return request('/api/routeAdjustSiteConfig/selectAdjustWeightSumBySitePage', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'temporary',
  });
}


/**
 * 查询临调承接已调货量汇总分页
 *
 * @param params 查询参数
 * @returns 返回请求结果
 */
export async function selectAdjustWeightSumBySiteExport(params) {
  return request('/api/routeAdjustSiteConfig/selectAdjustWeightSumBySiteExport', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'temporary',
  });
}
